import appConfig from '../../config/appConfig';
import {initDataConfig} from '../../config/dataConfig/dataConfig';
import externalConfigService from '../../config/externalConfigService';
import ageGatePageService from '../../containers/AgeGatePage/ageGatePageService';
import urlUtils from '../../utils/urlUtils';
import authService from '../auth/authService';
import connectivityService from '../device/connectivityService';
import {initLocalizations} from '../localization/localizationService';
import log from '../logger/log';
import appRouterService from '../route/appRouterService';
import userBrowserService from '../user/userBrowserService';
import userDeviceService from '../user/userDeviceService';

const onAppStart = async () => {
    try {
        await authService.login();
        await onAppInit();
        await initLocalizations();
    } catch (e) {
        log.error(`appService: onAppStart, error: ${e}`);
    }
};

const initializeStartActions = async () => {
    await onAppStart();
    await externalConfigService.initExternalConfig();
};

const onAppInit = async () => {
    log.info(`appService: app is initialized, ua: ${userBrowserService.getUserAgent()}`);

    await initDataConfig();
};

const getAppBaseUrl = () => {
    const baseName = appConfig.getBaseNameFormatted();
    const originLocation = urlUtils.getOriginLocation();
    const baseUrl = urlUtils.join(originLocation, baseName);

    return baseUrl;
};

const forwardToInitialPage = () => {
    const isAppLocked = ageGatePageService.isAppLocked();

    if (isAppLocked) {
        appRouterService.forwardToAppLockedPage();
        return;
    }

    const isAgeGateApproved = ageGatePageService.isAgeGateApproved();

    if (isAgeGateApproved) {
        forwardToPreBrowserCheckPage();
        return;
    }

    appRouterService.forwardToAgeGatePage();
};

const forwardToPreBrowserCheckPage = () => {
    const isUsb = connectivityService.isUsb();

    if (isUsb || userDeviceService.isDesktopDevice()) {
        appRouterService.forwardToBrowserVerificationPage();
    } else {
        appRouterService.forwardToImportantPage();
    }
};

export default {
    getAppBaseUrl,
    initializeStartActions,
    forwardToInitialPage,
    forwardToPreBrowserCheckPage,
};
